import React from 'react';
import { getRICSchemaForState } from '@upstart/harmony/lib/ric-form-utils';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { renderElement } from './SchemaComponents/SchemaFormElementRenderer';

export function SchemaBasedRICForm({
  responseData,
  fetchResponseWithUpdatedData,
  state,
}: {
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  state?: string;
}) {
  const renderElements = () => {
    const ricFormSchema = getRICSchemaForState(state);
    if (ricFormSchema) {
      const { elements, metadata } = ricFormSchema;

      return elements.map(formElement =>
        renderElement({
          formElement,
          responseData,
          fetchResponseWithUpdatedData,
          ricMetadata: metadata,
        }),
      );
    }
    return null;
  };

  return <div className="form-container">{renderElements()}</div>;
}

export default SchemaBasedRICForm;
